export const FT5_ADD_TO_EVENT_TRACKING = 'ft5.tracking.addtoevent';
export const FT5_EVENT_TRACKING = 'ft5.tracking.event';
export const FT5_MOVE_TRACKING = 'ft5.tracking.move';
export const FT5_MOVE_ACTION_TRACKING = 'ft5.tracking.moveAction';
export const FT5_VIEW_TRACKING = 'ft5.tracking.view';
export const FT5_VIEW_FEATURES_TRACKING = 'ft5.tracking.viewFeatures';
export const FT5_ADD_ACTION_TO_EVENT_TRACKING = 'ft5.tracking.addactiontoevent';
export const FT5_TRACK_ON_NEXT_PAGE_IMPRESSION = 'ft5.tracking.trackOnNextPageImpression';

/**
 * sent from ui-aggregator if html for a component is loaded/replaced
 */
export const RELOAD_COMPONENT_TOPIC = 'ft5.components.reload';
/**
 * expected by ui-aggregator when a dimension was selected
 */
export const DIMENSION_SELECTED_TOPIC = 'ft5.ui-aggregation.dimensionsSelected';

export const RELOAD_DIMENSION_SELECTION_SHEET_COMPONENT_TOPIC = 'ft5.components.dimensionSelectionSheet.reload';
export const DIMENSION_SELECTED_IN_SHEET_TOPIC = 'ft5.ui-aggregation.dimensionsSelectedInSheet';

export const INVALID_DIMENSIONS_IN_SHEET_CONTENT_TOPIC = 'ft5.components.dimensionSelectionSheetContent.invalidDimensions';

export const OTTO_RETAILER_ID = '1000000';

export const OTTO_PACKAGE_SHIPPING_COST = 495;

export const CONFIG_TOGGLE_BROKEN_DIMENSIONS = 'CONFIG_FILTER_BROKEN_DIMENSIONS';

export const CONFIG_SHOW_WATO_BANNER = 'CONFIG_SHOW_WATO_BANNER';

export const LAST_SELECTED_VARIATION_ID_COOKIE_NAME = 'ft5-pdp-last-selected-variation-id';

export const CR_LANDING_PAGE_REVIEW_LIST_PAGE_SIZE = 30;
